
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.333 1H15v2.333h1V0h-4.667v1zM4.666 1V0H0v3.333h1V1h3.667zM1 10H0v3.333h4.667v-1H1V10zm10.333 2.333v1H16V10h-1v2.333h-3.667z","fill":"#fff"}})])
          )
        }
      }
    